import { FIND_COUNTRIES_QUERY, STATIC_IMAGE_URL_QUERY } from '@app/model/refdata/service/RefDataGraphQLQueries';
import Country from '@app/model/hotel/Country';
import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';


class RefDataService {
    public static staticImageUrl(filename: string) {
        return GraphQLExecutor.execute<string>(STATIC_IMAGE_URL_QUERY, {filename})
    }

    public static findCountries() {
        return GraphQLExecutor.execute<Country[]>(FIND_COUNTRIES_QUERY)
    }

    public static findCountryPhonePrefixes() {
        return GraphQLExecutor.execute<Country[]>(FIND_COUNTRIES_QUERY, {sortBy: 'country_abbreviation'})
    }
}

export default RefDataService;